import moment from "moment";
import React, { useState } from "react";
import { amountFormat } from "../../utils";
import styles from "./BenefitIllustration.module.css";
import EnforcedLineChart from "./EnforcedLineChart";

export default function UlipComponents({ data, formik }) {
  const lastYearData = data?.graphData
    ? data?.graphData[data?.graphData.length - 1]
    : {};

  const loyaltySum = data?.graphData.reduce(
    (partialSum, item) => partialSum + item.loyaltyAdditions,
    0
  );
  const firstLoyaltyYear = data?.graphData.find(item => item.loyaltyAdditions > 0)?.policyYear;
  const wealthBoosterSum = data?.graphData.reduce(
    (partialSum, item) => partialSum + item.wealthBoosters,
    0
  );
  const firstWealthBoosterYear = data?.graphData.find(item => item.wealthBoosters > 0)?.policyYear;
  const fundDiscontinued = data?.graphData[4].endYearFundValueDiscontinued;
  const liquidationDateCalculated = moment(data?.policy.issueDate)
    .add(5, "years")
    .format("D MMM YYYY");

  const funds = Array.isArray(data?.funds) ? data.funds : [];
  const itemsPerPage = 7;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(funds.length / itemsPerPage);

  const paginatedFunds = funds.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  return (
    <div className="d-flex flex flex-column gap-5">
      <div className="bg-white py-4 rounded border px-5 flex d-flex flex-column gap-3">
        <div className="flex d-flex justify-content-between align-items-center gap-3">
          <span className={styles["sub-heading"]}> Your Policy Summary</span>
          <span className={styles["sub-heading-icon"]}>02</span>
        </div>
        <div>
          <ul>
            <li>
              You choose - <strong>{data?.policy?.product?.productName}</strong>
            </li>
            <li>
              As per your plan you need to pay{" "}
              <strong>{data?.policy?.premiumPaymentTerm}</strong> Premiums
            </li>
            <li>
              You paid <b>{data?.policy?.premiumPaidTerm}</b> premiums & need to
              pay <b>{data?.policy?.premiumDueTerm}</b> premiums more
            </li>
            <li>
              Your policy is currently{" "}
              <span style={{ color: "red", fontWeight: "bold" }}>
                Discontinued
              </span>{" "}
              & fund moved to debt from equity
            </li>
            <li>
              Your <b>Death Benefit</b> reduced to ₹
              <span style={{ color: "red", fontWeight: "bold" }}>
                {amountFormat(formik?.values?.currentFundValue)}
              </span>{" "}
              from ₹{amountFormat(data?.policy?.sumAssured)}
            </li>
          </ul>
        </div>
      </div>
      <div className="bg-white py-4 rounded border px-5 flex d-flex flex-column gap-3">
        <div className="flex d-flex justify-content-between align-items-center gap-3">
          <span className={styles["sub-heading"]}>
            {" "}
            Projected Fund Growth if you continue to pay premium
          </span>
          <span className={styles["sub-heading-icon"]}>03</span>
        </div>
        <div>
          {/* {data && (
          <EnforcedBarChart2
            data={data?.graphData}
            roi={formik?.values?.returnCalculation}
          />
        )} */}
          {data && (
            <EnforcedLineChart
              data={data?.graphData}
              roi={formik?.values?.returnCalculation}
            />
          )}
        </div>

        <div className="row">
          <div className="col-12 col-lg-4 mb-3">
            <div
              className="border p-2 h-100  rounded"
              style={{ backgroundColor: "#B8FF94	" }}
            >
              You pay total{" "}
              <b>₹{amountFormat(data?.policy?.totalPremiumValue)}</b> for{" "}
              <b>{data?.policy?.premiumPaymentTerm}</b> years and get{" "}
              <b>₹{amountFormat(lastYearData?.endYearFundValue)}</b> back after{" "}
              <b>{data?.policy?.policyTerm}</b> years @
              <b>{formik.values?.returnCalculation}%</b>
            </div>
          </div>
          <div className="col-12 col-lg-4 mb-3">
            <div
              className="border p-2 h-100 rounded"
              style={{ backgroundColor: "#FFFFB3	" }}
            >
              You pay total{" "}
              <b>₹{amountFormat(data?.policy?.totalPremiumValue)}</b> for{" "}
              <b>{data?.policy?.premiumPaymentTerm}</b> years and get{" "}
              <b>₹{amountFormat(lastYearData?.endYearFundValueFixed)}</b> back
              after <b>{data?.policy?.policyTerm}</b> years @8%
            </div>
          </div>
          <div className="col-12 col-lg-4 mb-3">
            <div
              className="border p-2 h-100  rounded"
              style={{ backgroundColor: "#FF8F8F		" }}
            >
              You paid <b>₹{amountFormat(data?.policy?.annualPremiumPaid)}</b>{" "}
              till now and will get only{" "}
              <b>₹{amountFormat(fundDiscontinued)}</b> on{" "}
              <b>{liquidationDateCalculated}</b> and your Death Benefit reduced
              to <b>₹{amountFormat(formik?.values?.currentFundValue)}</b>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-4 rounded border px-5 flex d-flex flex-column gap-3">
        <div className="flex d-flex justify-content-between align-items-center gap-3">
          <span className={styles["sub-heading"]}>
            {" "}
            Fund Performance% (funds available)
          </span>
          <span className={styles["sub-heading-icon"]}>04</span>
        </div>
        <div className="container mt-4">
          <div className={styles["sub-table-responsive"]}>
            <table className={styles["sub-table"]}>
              <thead>
                <tr>
                  <th style={{ width: "70%" }}>Fund</th>
                  <th className="text-center" style={{ width: "15%" }}>
                    1 Year
                  </th>
                  <th className="text-center" style={{ width: "15%" }}>
                    3 Year
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedFunds.length > 0 ? (
                  paginatedFunds.map((item, index) => (
                    <tr key={index}>
                      <td className={styles["sub-td"]}>{item.name}</td>
                      <td className={`${styles["sub-td"]} text-center`}>
                        {item.fmcPreviousYear}%
                      </td>
                      <td className={`${styles["sub-td"]} text-center`}>
                        {item.fmcTwoYearsAgo}%
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center py-3">
                      No fund data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination Controls */}
            {funds.length > itemsPerPage && (
              <div className="d-flex justify-content-end mt-2">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (pageNum) => (
                    <button
                      key={pageNum}
                      className={`btn btn-sm mx-1 ${
                        pageNum === currentPage
                          ? "btn-primary"
                          : "btn-outline-primary"
                      }`}
                      onClick={() => handlePageChange(pageNum)}
                    >
                      {pageNum}
                    </button>
                  )
                )}
              </div>
            )}
          </div>
        </div>
        <hr />
        <div className="flex d-flex align-items-center gap-3 ">
          {" "}
          <span className={styles["sub-heading"]}> Fund Chosen -</span>
          <span>{data?.fundCharges?.name}</span>
        </div>
      </div>

      <div className="bg-white py-4 rounded border px-5 flex d-flex flex-column gap-3">
        <div className="flex d-flex justify-content-between align-items-center gap-3">
          <span className={styles["sub-heading"]}>
            {" "}
            Your Additional Policy Benefits
          </span>
          <span className={styles["sub-heading-icon"]}>05</span>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-4 mb-3 d-flex">
              <div
                className={`${styles["sub-gradient-card"]} p-4 h-100 d-flex flex-column justify-content-center w-100`}
              >
                Death Benefit ₹{amountFormat(data?.policy?.sumAssured)}
              </div>
            </div>
            {loyaltySum >0 && (
              <div className="col-12 col-lg-4 mb-3 d-flex">
                <div
                  className={`${styles["sub-gradient-card"]} p-4 h-100 d-flex flex-column justify-content-center w-100`}
                >
                  Loyalty Addition* ₹{amountFormat(loyaltySum)} *From {firstLoyaltyYear}th year
                </div>
              </div>
            )}
            {wealthBoosterSum>0 && (
              <div className="col-12 col-lg-4 mb-3 d-flex">
                <div
                  className={`${styles["sub-gradient-card"]} p-4 h-100 d-flex flex-column justify-content-center w-100`}
                >
                  Wealth Boosters* ₹{amountFormat(wealthBoosterSum)} *{firstWealthBoosterYear}th year
                  and at maturity
                </div>
              </div>
            )}
            <div className="col-12 col-lg-4 mb-3 d-flex">
              <div
                className={`${styles["sub-gradient-card"]} p-4 h-100 d-flex flex-column justify-content-center w-100`}
              >
                Tax Benefits U/S 80C & 10(10D)
              </div>
            </div>
            <div className="col-12 col-lg-4 mb-3 d-flex">
              <div
                className={`${styles["sub-gradient-card"]} p-4 h-100 d-flex flex-column justify-content-center w-100`}
              >
                12 free switches annually
              </div>
            </div>
          </div>
        </div>
        <strong>
          *The proceeds will be completely tax-free or taxed as LTCG.
        </strong>
      </div>
    </div>
  );
}
